<template>
  <BaseNotification
    type="warning"
    layout="inline"
  >
    <div class="font-semibold mb-5 mt-px">
      <template v-if="people > capacity.max">
        Maximum capacity exceeded
      </template>
      <template v-else-if="isMinCapacityWarning">
        Minimum guest requirement
      </template>
    </div>
    {{ message }}
  </BaseNotification>
</template>

<script>
import BaseNotification from '@/components/Ui/BaseNotification.vue';

export default {
  name: 'CapacityExceededBanner',
  components: { BaseNotification },
  props: {
    people: {
      type: [Number, null],
      required: true,
    },
  },
  computed: {
    isMinCapacityWarning() {
      return this.people < this.capacity.min;
    },
    capacity() {
      return this.$store.state.room.capacity;
    },
    message() {
      if (this.isMinCapacityWarning) {
        return `Please note, this space is tailored for events with ${this.capacity.min} or more guests.`;
      }

      const beginning = 'For safety reasons, this room cannot host more than ';
      if (this.capacity.standing && this.capacity.sitting) {
        return `${beginning} ${this.capacity.standing} people standing or ${this.capacity.sitting} people sitting.`;
      }
      if (!this.capacity.standing) {
        return `${beginning} ${this.capacity.sitting} people sitting.`;
      }
      return `${beginning} ${this.capacity.standing} people standing.`;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
